module.exports = __webpack_public_path__ + "img/spartan-bio-square.374975f4.jpg";